/**
 * Single source of truth for the copy shown when conversational search is unavailable for the
 * current content type. It is surfaced in three places — the toggle's `aria-label`, the dedicated
 * CTA button's label, and the tooltip body — which must never drift apart.
 *
 * The supported set mirrors `isSearchWithAIEnabledForContentType` in `useSearchWithAI`: the video
 * family, plus audio when the `showConversationalSearchAudio` experiment is on. The message must be
 * derived from that same flag rather than hardcoded, otherwise it claims audio is unsupported while
 * the gate actually permits it.
 */
export function getConversationalSearchUnavailableMessage(showConversationalSearchAudio: boolean): string {
    const supportedContent = showConversationalSearchAudio ? 'video and audio content' : 'video content';
    return `Conversational Search is only available for ${supportedContent}.`;
}
